export const PUBLIC_ROUTE = {
  LANDING: "/",
  SIGN_IN: "/login",
  SIGN_UP: "/register",
  FORGET_PASSWORD: "/forgotpassword",
  VERIFY_EMAIL: "/verify-email",
  INVITE_ACCEPT: "/invitation-accept",
  COMPANYINVITE: "/company-invitation-accept",
};

export const PRIVATE_ROUTE = {
  DASHBOARD: "/",
};
